import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import './CookieConsent.scss';

const CookieConsent: React.FC<{ children: React.ReactNode; onAccept: () => void }> = ({ children, onAccept }) => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = Cookies.get('user-consent');
    if (!consent) {
      setShowBanner(true);
    } else if (consent === 'true') {
      onAccept();
    }
  }, [onAccept]);

  const handleAccept = () => {
    Cookies.set('user-consent', 'true', { expires: 365 });
    setShowBanner(false);
    onAccept();
    window.dispatchEvent(new CustomEvent('cookie-change'));
  };

  const handleDecline = () => {
    Cookies.set('user-consent', 'false', { expires: 365 });
    setShowBanner(false);
    window.dispatchEvent(new CustomEvent('cookie-change'));
  };

  return (
    <>
      {showBanner && (
        <div className="cookie-consent-banner show">
          <p>We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.</p>
          <div className="button-group">
            <button onClick={handleAccept}>Accept</button>
            <button onClick={handleDecline}>Decline</button>
          </div>
        </div>
      )}
      {children}
    </>
  );
};

export default CookieConsent;
